import {
    Alert,
    Box,
    Button,
    Card,
    CircularProgress,
    Grid,
    TextField,
    Typography,
    useMediaQuery,
    useTheme,
} from "@mui/material";
import { useState } from "react";
import { POST } from "../../../Utilities/BaseService";

const ChangedBasedLineUnits = () => {
    const theme = useTheme();
    const mdDown = useMediaQuery(theme.breakpoints.down("md"));

    const [meterNo, setMeterNo] = useState("");
    const [startMonthStr, setStartMonthStr] = useState("");
    const [baselineUnits, setBaselineUnits] = useState("");
  

    const [loading, setLoading] = useState(false);
    const [feedback, setFeedback] = useState<any>({
        severity: "",
        message: "",
        show: false,
    });

    const handleSubmit = async (ev: any) => {
        ev.preventDefault();
        setLoading(true);
        setFeedback({ show: false, message: "", severity: "" });

        if (!meterNo || !startMonthStr || !baselineUnits ) {
            setFeedback({
                message: "Please fill in all fields (Meter No, Start Month, BaseLine Units)",
                severity: "error",
                show: true,
            });
            setLoading(false);
            return;
        }

        const [startYear, startMonth] = startMonthStr.split("-").map(Number);
     
        try {
            const res = (await POST("/reading/changed-baseline-units", {
                meterNo,
               month: startMonth,
               year: startYear,
               baselineUnits,
               
            })) as any;

            setFeedback({
                message: res.data.message || `Successfully changed baseLineUnits`,
                severity: "success",
                show: true,
            });
            setLoading(false);
        } catch (error: any) {
            console.log(error, "error");
            setFeedback({
                message:
                    error?.response?.data?.message ||
                    "Failed to changed baseLineUnits",
                severity: "error",
                show: true,
            });
            setLoading(false);
        }
    };

    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                height: mdDown ? "auto" : `calc(100vh - 96px)`,
            }}
        >
            <Card
                elevation={0}
                sx={{ bgcolor: theme.palette.common.white, p: 2, mb: "1rem" }}
            >
                <Typography
                    variant="h5"
                    sx={{ p: "4px", mb: "4px" }}
                    color="GrayText"
                >
                    Changed BaseLine Units
                </Typography>

                <Grid container spacing={2}>
                    <Grid item xs={12} md={4}>
                        <TextField
                            label="Meter No."
                            fullWidth
                            size="small"
                            value={meterNo}
                            onChange={(e) => setMeterNo(e.target.value)}
                            required
                        />
                    </Grid>

                    <Grid item xs={12} md={4}>
                        <TextField
                            size="small"
                            label="Billing Month"
                            type="month"
                            fullWidth
                            value={startMonthStr}
                            onChange={(e) => setStartMonthStr(e.target.value)}
                            required
                            InputLabelProps={{ shrink: true }}
                        />
                    </Grid>


                    <Grid item xs={12} md={4}>
                        <TextField
                            label="BaseLine Units"
                            fullWidth
                            size="small"
                            value={baselineUnits}
                            onChange={(e) => setBaselineUnits(e.target.value)}
                            required
                        />
                    </Grid>

                 

                    <Grid item xs={12} md={4}>
                        <Button
                            variant="outlined"
                            color="secondary"
                            fullWidth
                            onClick={handleSubmit}
                            disabled={loading || !meterNo || !startMonthStr || !baselineUnits }
                            endIcon={
                                loading ? <CircularProgress size="1rem" color="inherit" /> : null
                            }
                        >
                            Change  Base Line Units
                        </Button>
                    </Grid>

                    {feedback.show && (
                        <Grid item xs={12}>
                            <Alert severity={feedback.severity}>
                                {feedback.message}
                            </Alert>
                        </Grid>
                    )}
                </Grid>
            </Card>
        </Box>
    );
};

export default ChangedBasedLineUnits;
